module.exports = __webpack_public_path__ + "static/media/kitchen-6.b239a86b.jpg";